import { memo } from 'react';

import { ModalCloseButton } from '@air/primitive-modal';

import { SelectedItemListSummary } from '~/components/SharePrivateCollectionModal/components/SelectedItemListSummary';

export type SharePrivateCollectionModalHeaderProps = {
  onClose: AirModalProps['onClose'];
};

export const CreateSharePrivateCollectionModalHeader = memo(({ onClose }: SharePrivateCollectionModalHeaderProps) => (
  <div className="flex items-center justify-between border-b border-b-grey-5 px-8 py-6">
    <div className="flex flex-col">
      <div className="font-semibold text-24 text-grey-12 leading-8">Create share link</div>
      <SelectedItemListSummary />
    </div>
    <ModalCloseButton
      className="shrink-0"
      onClick={onClose}
      data-testid="SHARE_PRIVATE_COLLECTION_MODAL_HEADER_CLOSE_BUTTON"
    />
  </div>
));

CreateSharePrivateCollectionModalHeader.displayName = 'CreateSharePrivateCollectionModalHeader';
